import { CookieOptions, CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject, interval, tap } from 'rxjs';
import { TosterService } from './toster.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  private tokenFromUI: string = "0123456789123456";
  expiryQrData$ = new BehaviorSubject<boolean>(false);  // Observable for expiry event

  constructor(private cookiesService: CookieService, private toastr: TosterService) { }

  // ***************************************local storage related functions********************************************
  // storing items to the local storage
  setItem(key: string, item: any) {
    this.encryptUsingAES256(key, item);
  };

  // getting item from local storage
  getItem(key: string) {

    let encryptedData = sessionStorage.getItem(key);
    let data = this.decryptUsingAES256(encryptedData);
    return data ? JSON.parse(data) : false;
  };

  // clearing everything from local storage
  clearStorage() {
    sessionStorage.clear();
  };

  // removing an item from session storage
  removeItem(key: string) {
    sessionStorage.removeItem(key);
  };


  // *********************************cookies related function********************************************************
  setCookies(key, value, expires?: any) {
    const now = new Date();
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    const expire = expires ?? endOfDay;
    this.encryptUsingAES256(key, value, 'cookies', expire);
  };

  getCookies(key: any) {
    let cookiesValue = this.cookiesService.get(key);
    // console.log("local ", cookiesValue)
    let data = this.decryptUsingAES256(cookiesValue);
    // console.log("data ", data)
    return data ? JSON.parse(data) : '';
  };

  clearCookies() {
    this.cookiesService.deleteAll();
  }

  removeCookies(key: any) {
    this.cookiesService.delete(key);
  };
  // *****************************************************************************************************************


  encryptUsingAES256(key, request, storage?: any, expires?: any) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(request), _key, {
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    // let d = encrypted.toString();
    let d = encodeURIComponent(encrypted.toString());
    if (storage == 'cookies') {
      this.cookiesService.set(key, d, expires)
    }
    sessionStorage.setItem(key, d);
  };

  decryptUsingAES256(encryptedData): any {
    // let data = JSON.parse(encryptedData);
    if (encryptedData) {
      let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
      let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
      
      return CryptoJS.AES.decrypt(
        decodeURIComponent(encryptedData), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
    }

  };

  setCookieTillExpires(
    name: string,
    value: string,
    options: CookieOptions | undefined = undefined
  ) {
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999); // <-- This returns a timestamp internally but updates the date object itself

    options = {
      expires: endOfDay, // ✅ Must be a Date object, not number
      path: '/',
      sameSite: 'Lax',
      secure: false,
      ...options,
    };

    this.cookiesService.set(name, value, options);
  }


  getCookie(name) {
    return this.cookiesService.get(name);
  }

  deleteCookie(name) {
    return this.cookiesService.delete(name);
  }

  // Function to check expiry
  private checkExpiry() {
    const itemStr: any = this.getItem('dynamicQrCode');
    if (!itemStr) return;

    if (Date.now() >= itemStr.expiry) {
      sessionStorage.removeItem('dynamicQrCode');
      this.toastr.cleanupDynamicComponent();
      this.expiryQrData$.next(true);
      console.log("DynamicQrCode Session expired! Refreshing data...");
    }
  }

  // Start interval-based expiry checking
  startExpiryChecker() {
    interval(5000)
      .pipe(tap(() => this.checkExpiry()))
      .subscribe();
  }

}
